module.exports = __webpack_public_path__ + "static/media/channel-generic.2d7ab7f7.svg";